var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChamadaVozPerdida(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13028 14.9238L11.7201 12.334L16 15.319L15.0399 16.2791C14.4004 16.9186 13.4617 17.1558 12.5952 16.897C9.946 16.1055 7.5662 14.6546 5.45578 12.5442C3.34537 10.4338 1.89446 8.05401 1.10305 5.40483C0.844165 4.53829 1.08141 3.59958 1.72091 2.96008L2.68099 2L5.66599 6.27991L3.07619 8.86972",
    fill: "#E93F66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13028 14.9238L11.7201 12.334L16 15.319L15.0399 16.2791C14.4004 16.9186 13.4617 17.1558 12.5952 16.897C9.946 16.1055 7.5662 14.6546 5.45578 12.5442C3.34537 10.4338 1.89446 8.05401 1.10305 5.40483C0.844165 4.53829 1.08141 3.59958 1.72091 2.96008L2.68099 2L5.66599 6.27991L3.07619 8.86972",
    stroke: "#E93F66",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChamadaVozPerdida);
export default __webpack_public_path__ + "static/media/chamada-voz-perdida.1fea30fb.svg";
export { ForwardRef as ReactComponent };